var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-search",on:{"click":function($event){return _vm.$emit('click')}}},[_c('icon',{staticClass:"icon-search",attrs:{"name":"search","size":15}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }